import React, {useEffect, useRef, useState} from 'react';
import {useHistory, Link} from 'react-router-dom';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import {SmallBox} from "@components";
import {useTranslation} from "react-i18next";
import {checkRole} from "@app/services/mainService";
import * as dashboardService from "@app/services/dashboardService";
import {formatCurencyVI} from "@app/utils/CommonFunctions";
import {image_root} from "@app/const/AppSetting";

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);

export const options = {
    responsive: true,
    plugins: {
        legend: {
            display: false
        }
    },
};

const labels = ['Thứ hai', 'Thứ ba', 'Thứ tư', 'Thứ năm', 'OCT', 'NOV', 'DEC'];

export const data = {
    labels,
    datasets: [
        {
            backgroundColor: '#007bff',
            borderColor: '#007bff',
            data: [1757560000, 1457560000, 1157560000, 2057560000, 1857560000, 2457560000, 3217560000]
        },
        {
            backgroundColor: '#ced4da',
            borderColor: '#ced4da',
            data: [1357560000, 1157560000, 557560000, 1157560000, 1850560000, 2057560000, 2057560000]
        }
    ],
};

const Dashboard = () => {
    const [loading, setLoading] = useState(false);
    const [t] = useTranslation();
    const [thongkedashboard01, setThongkedashboard01] = useState({});
    const [dataTuan, setDataTuan] = useState(data);
    const [totalTuan, setTotalTuan] = useState(0);
    const [rsSanpham, setRsSanpham] = useState([]);
    const history = useHistory();

    // Track if component is mounted to prevent state updates after unmount
    const isMountedRef = useRef(true);

    const userTmp = localStorage.getItem("profile");
    //console.log('Dashboard: userTmp =', userTmp);

    if(userTmp) {
        const nv = JSON.parse(userTmp);
        if(nv && nv.role && nv.role.length > 0 && nv.role.includes("SALEMAN")) {
            history.push('/Capture');
        }
    }

    // Fixed useEffect - no async directly in useEffect
    useEffect(() => {
        const fetchDashboardData = async () => {
            try {
                console.log('Dashboard: Fetching dashboard data...');
                setLoading(true);

                const rs1 = await dashboardService.thongkedaohuunhadan();
                console.log('Dashboard: API response:', rs1);

                if(isMountedRef.current && rs1) {
                    setThongkedashboard01(rs1);
                }



            } catch (error) {
                console.error('Dashboard: Error fetching data:', error);
            } finally {
                if(isMountedRef.current) {
                    setLoading(false);
                }
            }
        };

        // fetchDashboardData();

        // Cleanup function
        return () => {
            console.log('Dashboard: Component unmounting');
            isMountedRef.current = false;
        };
    }, []); // Empty dependency array - runs only once

    function ImportData(data) {
        let total = 0;
        let val = [];
        Object.keys(data).forEach(key => {
            val.push(data[key]);
            total += data[key];
        });

        if(isMountedRef.current) {
            setTotalTuan(total);
        }
        return val;
    }

    if (loading) {
        return (
            <div className="flex justify-center items-center h-40">
                <div className="spinner-border text-primary" role="status">
                    <span className="sr-only">Loading...</span>
                </div>
            </div>
        );
    }

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-lg-3 col-6">
                    <SmallBox
                        count={thongkedashboard01 && thongkedashboard01.numdaohuu ? thongkedashboard01.numdaohuu : 0}
                        title="Số lượng đạo hữu của nhà đàn bạn được phân quyền"
                        type="info"
                        icon="ion-android-people"
                        navigateTo="/"
                    />
                </div>
                <div className="col-lg-3 col-6">
                    <SmallBox
                        count={thongkedashboard01 && thongkedashboard01.numnhadan ? thongkedashboard01.numnhadan : 0}
                        title="Số lượng nhà đàn trên hệ thống"
                        type="success"
                        navigateTo="/"
                    />
                </div>
                <div className="col-lg-3 col-6">
                    <SmallBox
                        count={thongkedashboard01 && thongkedashboard01.numdaohuutrongthang ? thongkedashboard01.numdaohuutrongthang : 0}
                        title="Số lượng đạo hữu phát sinh trong tháng hiện tại"
                        icon="ion ion-person-add"
                        type="warning"
                        navigateTo="/"
                    />
                </div>
                <div className="col-lg-3 col-6">
                    <SmallBox
                        count={thongkedashboard01 && thongkedashboard01.numnhadantrongthang ? thongkedashboard01.numnhadantrongthang : 0}
                        title="Số lượng nhà đàn phát sinh trong tháng hiện tại"
                        icon="ion ion-person-add"
                        type="danger"
                        navigateTo="/"
                    />
                </div>
            </div>
        </div>
    );
};

export default Dashboard;